<template>
  <div class="documents">
    <BasicAlert
      v-if="alertMessageBilan"
      alertLabel="Le document Bilan de positionnement est obligatoire si validation CQP et TFP de branche."
    />

    <div
      class="col-36"
      v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
    >
      <WrapperCheckbox
        id="field_attestationPiecesJustificatives"
        v-model="attestationPiecesJustificativesModel"
        :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
        label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt du dossier"
        :readonly
        class="wrapper-width-fit wrapper-without-margin-top"
      />
    </div>
    <UploadFichiers>
      <template
        #title
        v-if="enSimplificationAdministrative"
      >
        <BasicAlert
          alertType="danger"
          alertLabel="Vous êtes en « simplification administrative », vous n’avez donc pas l’obligation de nous transmettre les documents justificatifs sauf si votre dossier est lié à un cofinancement ou s’il s’agit d’un dossier AF PDC-50. "
          :hasBg="false"
        />
      </template>
    </UploadFichiers>
  </div>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { UploadFichiers } from '@/features/interface/demande/shared/components'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'
  import { useDemandeAFStore } from '../../useDemandeAFStore'

  const store = useDemandeAFStore()
  const { setupFieldWithKey } = useDemandeAFStore()

  const { meta, readonly, model, enSimplificationAdministrative } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives', true)

  const alertMessageBilan = computed(() => {
    return (
      model?.value?.employeur?.etablissement?.idcc?.code === '3043' &&
      (model?.value?.sousDispositif === 'PDC' || model?.value?.sousDispositif === 'ActionStandard')
    )
  })
</script>

<style scoped lang="less">
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;

    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
